var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vendor-performance-wrapper" }, [
    _c(
      "ul",
      {
        staticClass: "accordion accordion-customize",
        attrs: {
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-multi-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
          id: "vendor-performance-accordion",
        },
      },
      [
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("company.titles.vendorPerformance"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { "data-tab-content": "" },
              },
              [
                _c("div", { staticClass: "clearfix search-section" }, [
                  _c(
                    "div",
                    { staticClass: "select-trade" },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("company.performance.trade"))),
                      ]),
                      _vm._v(" "),
                      _c("HKLMultiSelect", {
                        attrs: {
                          value: _vm.searchCriteria.trade,
                          options: _vm.tradeHklOptions,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            _vm.searchCriteria.trade = val
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select-building" },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("company.performance.site"))),
                      ]),
                      _vm._v(" "),
                      _c("HKLMultiSelect", {
                        attrs: {
                          value: _vm.searchCriteria.site,
                          options: _vm.siteHklOptions,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            _vm.searchCriteria.site = val
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "select-date-range" }, [
                    _c("label", { staticClass: "emphasis" }, [
                      _vm._v(_vm._s(_vm.$t("company.performance.dateRange"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "date-picker" },
                      [
                        _c("DatePicker", {
                          staticClass: "columns date-range-picker",
                          attrs: {
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            placeholder: "From",
                            disabled: {
                              from: _vm.searchCriteria.endDay || new Date(),
                            },
                          },
                          model: {
                            value: _vm.searchCriteria.startDay,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchCriteria, "startDay", $$v)
                            },
                            expression: "searchCriteria.startDay",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "date-picker second-picker" },
                      [
                        _c("DatePicker", {
                          staticClass: "columns date-range-picker",
                          attrs: {
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            placeholder: "To",
                            disabled: {
                              from: new Date(),
                              to: _vm.searchCriteria.startDay,
                            },
                          },
                          model: {
                            value: _vm.searchCriteria.endDay,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchCriteria, "endDay", $$v)
                            },
                            expression: "searchCriteria.endDay",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          on: {
                            click: function ($event) {
                              return _vm.searchPerformance()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("company.performance.apply")))]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "small-5 medium-5 large-5 column" },
                    [
                      _c(
                        "div",
                        { staticClass: "column-wrapper" },
                        [
                          _c("ProjectPerformance", {
                            attrs: {
                              tenders: _vm.tenders,
                              projects: _vm.projects,
                              startDay: _vm.searchCriteria.startDay,
                              endDay: _vm.searchCriteria.endDay,
                              companyId: _vm.companyId,
                              description: _vm.companyName,
                              site: _vm.searchCriteria.site,
                              trade: _vm.searchCriteria.trade,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "small-7 medium-7 large-7 column" },
                    [
                      _c(
                        "div",
                        { staticClass: "column-wrapper" },
                        [
                          _c("QuotationKpi", {
                            attrs: {
                              tendersData: _vm.tenders,
                              companyId: _vm.companyId,
                              projects: _vm.projects,
                              startDay: _vm.searchCriteria.startDay,
                              endDay: _vm.searchCriteria.endDay,
                              purchaseAmounts: _vm.purchaseAmounts,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }